import { useSelector } from "react-redux"
import Icons from "../../assets/Icons"

const Daily = () => {

    const extendedForecastData = useSelector(state => state.weatherData.extendedForecast)

    if (extendedForecastData.length > 7) {

        extendedForecastData.shift()

    }


    const forecast = extendedForecastData.map((data, id) => {
        return <div className="forecast-container" key={id}>
            <div className=" row dflex">
                <p className="forecast__date">{(new Date ((data.dt) * 1000)).toLocaleString('en-US', {weekday: "short", month: "short", day: "numeric"})}</p>
                
                <div className="forecast__wrapper dflex">
                <div className="forecast__img">
                    <img src={Icons[`icon_${data.weather[0].icon}`]}/>
                </div>
                    <div className="forecast__temps" >
                        <div className="forecast__temps--img">
                            <img src={require("../../img/caret-down-solid.svg").default} />
                        </div>
                        <p><span>{(data.temp.min).toFixed(0)}°</span></p>
                    </div>
                    <div className="forecast__temps" >
                        <div className="forecast__temps--img">
                            <img src={require("../../img/caret-up-solid.svg").default} />
                        </div>
                        <p><span>{(data.temp.max).toFixed(0)}°</span></p>
                    </div>
                </div>
            </div>
            
            
        </div>
    })




    return (
        
            <div className="forecast">{forecast}</div>
            
        
    )
}

export default Daily
